import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { API_URL } from "../../constant";

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAllowed, setIsAllowed] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const checkPermission = async () => {
      const token = localStorage.getItem("auth_token");
      
      if (!token) {
        setIsAllowed(false);
        setIsLoading(false);
        return;
      }

      try {
        const response = await fetch(`${API_URL}/api/agent/me`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          const data = await response.json();
          const userRole = data.user?.role;
          
          // Check if user role is allowed for this route
          // Mini agents should not see refer-agent
          if (location.pathname.includes("refer-agent")) {
            const isMiniAgent = userRole === "SeniorBusinessAdsAgent" ? false : true;
            setIsAllowed(!isMiniAgent);
          } else {
            setIsAllowed(true);
          }
        }
      } catch (error) {
        console.error("Error checking permission:", error);
        setIsAllowed(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkPermission();
  }, [location.pathname]);

  if (isLoading) {
    return (
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh"
      }}>
        <div className="spinner"></div>
      </div>
    );
  }

  if (!isAllowed) {
    // Redirect mini agents trying to access refer-agent to refer page
    if (location.pathname.includes("refer-agent")) {
      return <Navigate to="/retailer-business-agent/refer" replace />;
    }
    return <Navigate to="/retailer-business-agent/refer" replace />;
  }

  return children;
};

export default ProtectedRoute;